import { __require as r } from "./td-longtail-vue-components276.js";
var a = r();
export {
  a as v
};
